module.exports = __webpack_public_path__ + "static/media/apng_seohyun.87bb2ac0.png";